/* eslint-disable */
import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";

import * as IconsSVG from "../../../../assets/iconsSVG";
import images from "../../../../constants/images";
import MaterialUI from "../../../../material-UI";
import warn from "../../../../constants/toast";
import handleApiError from "../../../../utils/handleApiError";
import axiosLead from "../../../../services/lead";
import * as Styles from "../../styles";

interface Props {
  idLead?: string;
  idLeadCorretor: string;
  onClose: Function;
  open: boolean;
  isLeadScreen: boolean;
  hotRefreshFunc: Function;
}

const DesqualifyForm: React.FC<Props> = ({
  idLead,
  idLeadCorretor,
  onClose,
  open,
  isLeadScreen,
  hotRefreshFunc,
}) => {
  const [value, setValue] = useState({ id: "", nome: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [motivosDesqualificacao, setMotivoDesqualificacao] = useState<
    Array<{ id: string; nome: string }>
  >([]);
  const [descricao, setDescricao] = useState("");
  const [isConcluded, setIsConcluded] = useState<boolean>(false);

  useEffect(() => {
    requestDesqualificacao();
  }, []);

  useEffect(() => {
    if (value.nome.toLowerCase().replace(" ", "") !== "outros") {
      setDescricao("");
    }
  }, [value]);

  const requestDesqualificacao = async () => {
    try {
      const response = await axiosLead.GetDesqualificacao();
      setMotivoDesqualificacao(response.data.data);
    } catch (error) {
      console.log("Erro ao listar zonas.");
    }
  };

  const desqualificarfLead = async () => {
    try {
      if (value.nome.toLowerCase().replace(" ", "") === "") {
        toast.error("Selecione o motivo.");
        return;
      }
      setLoading(true);
      await axiosLead.desqualificarfLead(idLeadCorretor, {
        idLead,
        idMotivoDesqualificacaoLead: value?.id,
        descricaoMotivoDesqualificacaoLead: descricao,
      });
      toast.success("Lead desqualificado com sucesso.");
      if (isLeadScreen) {
        window.location.href = "/transferencia-concluida/desqualificado";
      } else {
        setIsConcluded(!isConcluded);
      }
    } catch (error: any) {
      handleApiError(error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Styles.TransferComponent>
        <Styles.Autocomplete
          id="combo-box-demo"
          options={motivosDesqualificacao}
          renderInput={(params: any) => (
            <>
              <Styles.LabelText>Motivo</Styles.LabelText>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Motivo"
              />
            </>
          )}
          getOptionLabel={(option: any) => option.nome || ""}
          onChange={(event, newValue: any) => {
            setValue(newValue);
          }}
        />
        {value.nome.toLowerCase().replace(" ", "") === "outros" && (
          <>
            <Styles.SpaceY space={16} />
            <Styles.LabelText>Descrição</Styles.LabelText>
            <Styles.TextField
              style={{ backgroundColor: "#ffffff" }}
              size="small"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              label="Título"
              fullWidth
              required
              value={descricao}
              className="input-disabled"
              onChange={(e) => setDescricao(e.target.value)}
            />
          </>
        )}
      </Styles.TransferComponent>
      <Styles.FooterFixed>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Styles.Button
            className="error-btn"
            color="secondary"
            variant="contained"
            onClick={desqualificarfLead}
          >
            {loading ? <MaterialUI.CircularProgress /> : "Desqualificar"}
          </Styles.Button>
        </Styles.FooterDialog>
      </Styles.FooterFixed>
      {isConcluded && (
        <Styles.ContainerConfirm className="desqualify-confirm">
          <Styles.HeaderContent>
            <Styles.BoxImgSuccess>
              <IconsSVG.SuccessIcon />
            </Styles.BoxImgSuccess>
            <Styles.HeaderTitle>Lead desqualificado</Styles.HeaderTitle>
          </Styles.HeaderContent>
          <Styles.InfoContent>
            <Styles.TitleInfo>
              Este lead não será mais exibido na sua carteira
            </Styles.TitleInfo>
            <Styles.BoxImgArt>
              <img src={images.transferSuccessArt} alt="Art Success" />
            </Styles.BoxImgArt>
            <Styles.LinkReturn
              onClick={() => {
                hotRefreshFunc();
                onClose(!open);
                setIsConcluded(!isConcluded);
              }}
            >
              Voltar para a carteira
            </Styles.LinkReturn>
          </Styles.InfoContent>
        </Styles.ContainerConfirm>
      )}
    </div>
  );
};

export default DesqualifyForm;
